module.exports = __webpack_public_path__ + "img/Meal voucher Icon - charcoal.84b44bcd.svg";